import http from "../http-common";

class LoginService {
  login(data) {
    return http.post("/login.php", data);
  }
}

export default new LoginService();